import { format, parse, isMatch, isValid } from "date-fns";
export const getBirthDateString = (date) => {
    if (date instanceof Date) {
        if (!isValid(date))
            throw new Error("Invalid date object");
        return format(date, "yyyy-MM-dd");
    }
    const input = String(date).trim();
    if (!input)
        return "";
    const patterns = ["dd.MM.yyyy", "dd/MM/yyyy", "yyyy-MM-dd"];
    for (const pattern of patterns) {
        if (isMatch(input, pattern)) {
            const parsed = parse(input, pattern, new Date());
            if (!isValid(parsed))
                break;
            return format(parsed, "yyyy-MM-dd");
        }
    }
    const fallback = new Date(input);
    if (!isValid(fallback)) {
        throw new Error(`Ugyldig fødselsdato-format: "${input}"`);
    }
    return format(fallback, "yyyy-MM-dd");
};
